import React, { FunctionComponent } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { DATA_QA } from '../../../helpers/data-qa';
import '../../../styles/ai-assistant.styles.scss';

type ModalDeleteProps = {
	setShowModal: (show: boolean) => void;
	showModal: boolean;
	saveAndInsert: () => void;
};

export const AiAssistantConfirmationModal: FunctionComponent<ModalDeleteProps> = ({ setShowModal, showModal, saveAndInsert }) => {
	const [t] = useTranslation();

	const closeModal = () => setShowModal(false);

	return (
		<Modal data-qa={DATA_QA.AI_TOOLS_PANEL_CONFIRMATION_MODAL} isOpen={showModal} className='ai-assistant-modal'>
			<ModalHeader
				className='border-0'
				toggle={() => {
					closeModal();
				}}
			>
				<span className='ai-assistant-modal-text-header'>{t('insert')}</span>
			</ModalHeader>
			<ModalBody className='border-0'>
				<span className='ai-assistant-modal-text'>{`${t('ai_assistant_confirmation_modal_description')}`}</span>
			</ModalBody>
			<ModalFooter className='border-0'>
				<div className='ai-assistant-modal-btns'>
					<div className='ai-assistant-modal-close-btn' onClick={closeModal}>
						<span className='ai-assistant-modal-close-btn-text'>{t('cancel')}</span>
					</div>
					<div onClick={saveAndInsert} className='ai-assistant-modal-continue-btn'>
						<span className='ai-assistant-modal-continue-button-text'>{t('ai_assistant_confirmation_modal_continue')}</span>
					</div>
				</div>
			</ModalFooter>
		</Modal>
	);
};
